angular.module('routes.cases.CasesPayloadResolver', [
  'stack'
])

/**
 * The CasesPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class CasesPayloadResolver
 * @constructor
 * @module routes.cases.CasesPayloadResolver
 */
.factory('CasesPayloadResolver', [
  '$q',
  '$rootScope',
  'GLOBAL',
  'ModelsService',
  'PaginationService',
  function ($q, $rootScope, GLOBAL, ModelsService, PaginationService) {
    'use strict';

    return function (params) {
      var queue = [];

      if (!params.caseId) {
        queue.push(PaginationService.paginate('cases', GLOBAL.apiPath + '/cases', { limit: 10 }));
        // queue.push(ModelsService.initialize('cases', GLOBAL.apiPath + '/cases'));
      } else {
        queue.push(ModelsService.get('cases', GLOBAL.apiPath + '/cases', { id: params.caseId }));
      }

      return $q
        .all(queue)
        .then(function (response) {
          var endpoint;
          var report;
          console.log('response', response);
          if (!$rootScope.report && params.caseId) {
            report = {
              label: 'report-' + uuid.v1(),
              content: {
                simulation: {
                  id: params.caseId,
                  title: response[0].label
                },
                timing: {
                  start: new Date().toISOString(),
                  end: null
                },
                events: []
              }
            };

            // create report
            endpoint = ModelsService.find('endpoints', 'label', 'reports');

            $rootScope.report = response;
            return ModelsService.create(endpoint, report);
          }
          return {};
        });
    };
  }
]);
